import { render, staticRenderFns } from "./PendingAndUserNotModifiedGroup.vue?vue&type=template&id=785dc952"
import script from "./pendingAndUserNotModifiedGroup.ts?vue&type=script&lang=ts&external"
export * from "./pendingAndUserNotModifiedGroup.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('785dc952')) {
      api.createRecord('785dc952', component.options)
    } else {
      api.reload('785dc952', component.options)
    }
    module.hot.accept("./PendingAndUserNotModifiedGroup.vue?vue&type=template&id=785dc952", function () {
      api.rerender('785dc952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/team-request-detail/buttons-group/groups/manager/pending-and-user-not-modified-group/PendingAndUserNotModifiedGroup.vue"
export default component.exports